import { List, Map, OrderedMap } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { DeploymentDetailMapper } from "features/planner/planner.mappers";

const initialState = Map({
  byCardId: Map(),
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_GROUP_OPEN_DEPLOYMENTS: {
      if (error) return state;

      return state
        .merge(
          ...payload.map(deployment =>
            deployment.deploymentDetails.map(deploymentDetail => [
              deploymentDetail.deploymentDetailId.toString(),
              DeploymentDetailMapper.from(deploymentDetail),
            ]),
          ),
        )
        .update("byCardId", byCardId =>
          byCardId.merge(
            Map(
              List()
                .concat(...payload.map(d => d.deploymentDetails))
                .groupBy(dd => dd.cardId.toString())
                .map(x => x.map(dd => dd.deploymentDetailId)),
            ),
          ),
        );
    }

    case ACTIONS.GET_CARD_ALL_DEPLOYMENTS: {
      if (error) return state;

      return state
        .merge(
          ...payload.map(d =>
            d.deploymentDetails.map(dd => [
              dd.deploymentDetailId.toString(),
              DeploymentDetailMapper.from(dd),
            ]),
          ),
        )
        .setIn(
          ["byCardId", action.cardId.toString()],
          List().concat(
            ...payload.map(d =>
              d.deploymentDetails.map(dd => dd.deploymentDetailId),
            ),
          ),
        );
    }

    case ACTIONS.GET_CARD_OPEN_DEPLOYMENTS:
    case ACTIONS.UPDATE_CARD_OPEN_DEPLOYMENT: {
      if (error || payload === null) {
        if (
          error?.status === 404 ||
          error?.status === 204 ||
          payload === null
        ) {
          const keys = state.getIn(["byCardId", action.cardId.toString()]);
          return state
            .deleteIn(["byCardId", action.cardId.toString()])
            .deleteAll(keys);
        }

        return state;
      }

      return state
        .merge(
          OrderedMap(
            payload.deploymentDetails?.map(dd => [
              dd.deploymentDetailId.toString(),
              DeploymentDetailMapper.from({
                ...dd,
                deploymentStart: payload.start,
              }),
            ]),
          ),
        )
        .update("byCardId", byCardId =>
          byCardId.merge(
            OrderedMap(
              List(payload.deploymentDetails)
                .groupBy(deploymentDetail => deploymentDetail.cardId.toString())
                .map(x =>
                  x.map(
                    deploymentDetail => deploymentDetail.deploymentDetailId,
                  ),
                ),
            ),
          ),
        );
    }

    case ACTIONS.UNLOAD_CARD_DEPLOYMENTS: {
      return initialState;
    }

    case ACTIONS.DELETE_DEPLOYMENT_DETAIL: {
      if (error) return state;

      const { cardId, deploymentDetailId } = action;

      return state
        .delete(deploymentDetailId.toString())
        .updateIn(["byCardId", cardId.toString()], deploymentDetails =>
          deploymentDetails.filterNot(
            deploymentDetail => deploymentDetail === deploymentDetailId,
          ),
        );
    }

    default:
      return state;
  }
};
